import { Fragment } from 'react';
import FieldWrapper from '../../../components/formInputs/FieldWrapper';
import useMultiSelectOptions from '../../../hooks/useMultiSelectOptions';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

interface SingleOrderRejectInputsProps {
  selectOptions: {
    label: string;
    value: string;
  }[];
}

export default function SingleOrderRejectInputs({ selectOptions }: SingleOrderRejectInputsProps) {
  const formik = useFormikContext<any>();
  const { t } = useTranslation();

  const { element } = useMultiSelectOptions({
    inputName: 'field_id',
    formik: formik,
    label: t('document'),
    placeholder: t('document'),
    selectOptions: selectOptions || []
  });

  return (
    <Fragment>
      {selectOptions?.length > 1 && element}
      {formik?.values?.field_id?.map((field: string) => {
        const fieldLabel = selectOptions?.find((option) => option?.value === field)?.label;
        return (
          <FieldWrapper
            title={t("comment_on", { field_name: fieldLabel || '' })}
            inputName={`comments[${field}]`}
            inputPlaceholder={t("comment_on", { field_name: fieldLabel || '' })}
            inputError={formik.errors.comment as string}
            inputTouched={formik.touched.comment as boolean}
            textArea
          />
        );
      })}
    </Fragment>
  );
}
